import { render, staticRenderFns } from "./buckupforbikes.vue?vue&type=template&id=eb5de2bc&scoped=true&"
import script from "./buckupforbikes.vue?vue&type=script&lang=js&"
export * from "./buckupforbikes.vue?vue&type=script&lang=js&"
import style0 from "./buckupforbikes.vue?vue&type=style&index=0&id=eb5de2bc&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5de2bc",
  null
  
)

export default component.exports